import { REHYDRATE } from 'redux-persist/constants'
import DynamicReducer, { defaultState as dynReducerDefaultState } from '../commons/Redux/DynamicReducer'

export const defaultState = dynReducerDefaultState
export const dynamicReducer = new DynamicReducer()

export default dynamicReducer.install()

const reducer = (state, action) => {
    state = state || defaultState
    if (action.type === REHYDRATE) {
        state = state.merge(action.payload)
    }
    return state
}

dynamicReducer.addGlobal(reducer, 'App')
